import {
  ActionType,
  FullStressTypeCSVDownloadResponse,
  IFullStressTypeDownloadCsvData,
} from "models/stressCheck/fullStressTypeDownloadCsv";

export const fullStressCsvDownloadAction = (
  payload: IFullStressTypeDownloadCsvData
) => {
  return {
    type: ActionType.FULL_STRESS_TYPE_DOWNLOAD_CSV,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.FULL_STRESS_TYPE_DOWNLOAD_CSV_ERROR,
    payload,
  };
};

export const handleSuccesAction = (
  payload: FullStressTypeCSVDownloadResponse
) => {
  return {
    type: ActionType.FULL_STRESS_TYPE_DOWNLOAD_CSV_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.FULL_STRESS_TYPE_DOWNLOAD_CSV_RESET_DATA,
  };
};
